export enum LocalStorageKeysEnum {
  DelegateAsUserDetailID = 'delegate.as.userDetailID',
}
